import React, { FC } from 'react'

import { IconTrophyProps } from './IconTrophy.types'
import * as Styled from './styles/IconTrophy.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTrophy: FC<IconTrophyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTrophyProps['size'],
  isResponsive = false,
}: IconTrophyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M34.358 6.945h6.655S40.44 14.967 38 17.41c-2.75 2.75-5.635 1.545-5.635 1.545m-19.07-12.01H6.643s.57 8.022 3 10.465c2.75 2.75 5.635 1.545 5.635 1.545'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M17.383 43a6.617 6.617 0 0 1 13.235 0H17.383ZM34.358 6.945l-2.595 15.642c-1.25 5.663-4.085 6.468-7.935 6.468-3.85 0-6.665-.805-7.935-6.468L13.298 6.945h21.06Zm-10.531 22.11v7.325'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTrophy
